// src/services/feedbackService.js
import api from './api';

const submitFeedback = async (feedbackData) => {
  try {
    const response = await api.post('/feedback', feedbackData);
    return response;
  } catch (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
};

const feedbackService = {
  submitFeedback,
};

export default feedbackService;